import { useContext, useEffect, useState } from "react";
import useTranslator from "../../hooks/useTranslator";
import { Container } from "react-bootstrap";
import AuthContext from "../../context/auth/AuthContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { haveValue, toast } from "../../helper/common";
import Loader from "../../components/Loader";

const GdprConsent = () => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { getTenantNameAndDni, acceptConsent } = useContext(AuthContext);
  const [queryParams] = useSearchParams();
  const [currentLang, setCurrentLang] = useState("en-us");
  const [name, setName] = useState("Jon Doe");
  const [identity, setIdentity] = useState("N/A");
  const [consentDocLoading, setConsentDocLoading] = useState(false);
  const [localLoading, setLocalLoading] = useState(true);

  useEffect(() => {
    getTenantNameAndDni(queryParams.get("userId"))
      .then((res) => {
        const data = res.success_res;
        setName(`${data?.fname ?? ""} ${data?.lname ?? ""}`);
        if (haveValue(data?.dni_nie)) {
          setIdentity(data?.dni_nie);
        } else if (haveValue(data?.passport_id)) {
          setIdentity(data?.passport_id);
        }
        if (data?.docSigned == "COMPLETED") {
          if (haveValue(localStorage.getItem("token"))) {
            navigate("/tenant");
          } else {
            navigate("/auth");
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLocalLoading(false);
      });
  }, []);

  const handleAddConsent = async () => {
    setConsentDocLoading(true);
    acceptConsent(queryParams.get("userId"))
      .then((res) => {
        toast.success(_t("consentSubmitted"));
        if (haveValue(localStorage.getItem("token"))) {
          navigate("/tenant");
        } else {
          navigate("/auth");
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setConsentDocLoading(false);
      });
  };

  return (
    <>
      {localLoading ? (
        <Loader />
      ) : (
        <>
          <div id="header" className="head-cus position-sticky top-0">
            <div className="header-left header-tenant-left float-left custom-header">
              <h5 className=" w-100 justify-content-center">
                <img
                  src="/images/Skor_dark_green_logo.svg"
                  id="skor_navbar_logo"
                  alt=""
                />
              </h5>
            </div>
          </div>

          <Container className="py-5">
            <div className="tenant-consent-paragraph w-100">
              {currentLang === "en-us" ? (
                <div className="pt-2">
                  <p>
                    I, <b>{name}</b>, holder of ID/NIE/passport number{" "}
                    <b>{identity}</b> and acting as a tenant, AUTHORIZE MadRent
                    Ventures, S.L. (hereinafter, "SKOR") to disclose my personal
                    data, specifically identifying information, payment data,
                    and credit information, by the terms outlined below:
                  </p>
                  <p>
                    In compliance with Regulation (EU) 2016/679 of the European
                    Parliament and of the Council of 27 April 2016 on the
                    protection of natural persons about the processing of
                    personal data and on the free movement of such data, and
                    repealing Directive 95/46/EC (GDPR), it is hereby informed
                    that the data provided will be processed by the following
                    entities:
                  </p>
                  <p>
                    • Credit companies and creditworthiness databases, to
                    consult credit history and possible defaults, in order to
                    assess the profile and facilitate access to financial
                    products.
                    <br />• Third-party collaborators in the financial sector,
                    to analyze economic solvency and the ability to meet
                    financial obligations, assessing the viability of the rental
                    agreement. <br />
                    • Insurance companies, to evaluate the economic situation
                    within the framework of contracting guarantee products
                    against non-payment of rent and decide on their approval.{" "}
                    <br />
                    •Property owners and real estate agents involved in the
                    rental process, to review the economic profile and make
                    informed decisions regarding the rental agreement.
                  </p>
                  <p>
                    SKOR guarantees the implementation of technical and
                    organizational measures to protect data security and ensures
                    that no personal data is shared with third parties except
                    when legally required.
                  </p>
                  <p>
                    You may exercise your rights of access, rectification,
                    erasure, objection, restriction of processing, data
                    portability, and the right to be forgotten, as well as
                    revoke your consent, by sending your request to
                    info@skortorent.com. You may also file a complaint with the
                    Spanish Data Protection Agency (www.aepd.es).
                  </p>
                  <p>
                    I confirm that I have read and understood the content of
                    this document, giving my free, specific, informed, and
                    unequivocal consent to the transfer of my data under the
                    terms stated above.
                  </p>
                </div>
              ) : (
                <div className="pt-2">
                  <p>
                    Yo, <b>{name}</b>, con DNI/NIE/pasaporte número{" "}
                    <b>{identity}</b> y actuando en calidad de inquilino,
                    AUTORIZO a MadRent Ventures, S.L. (en adelante, "SKOR") a
                    comunicar mis datos personales, y en concreto, datos
                    personales identificativos, datos de pago, información
                    crediticia, conforme a los términos indicados a
                    continuación:
                  </p>
                  <p>
                    En cumplimiento del Reglamento (UE) 2016/679 del Parlamento
                    Europeo y del Consejo, de 27 de abril de 2016, relativo a la
                    protección de las personas físicas en lo que respecta al
                    tratamiento de datos personales y a la libre circulación de
                    estos datos, y por el que se deroga la Directiva 95/46/CE
                    (RGPD), se informa que los datos proporcionados serán
                    tratados por las siguientes entidades:
                  </p>
                  <p>
                    • Compañías de crédito y ficheros de solvencia patrimonial,
                    para consultar historial crediticio y posibles impagos, con
                    el objetivo de valorar el perfil y facilitar el acceso a
                    productos financieros.
                    <br />• Terceros colaboradores del sector financiero, para
                    analizar solvencia económica y capacidad de cumplimiento de
                    obligaciones financieras, evaluando la viabilidad del
                    arrendamiento.
                    <br />
                    • Compañías aseguradoras, para analizar la situación
                    económica en el marco de contratación de productos de
                    garantía frente al impago de rentas y decidir sobre su
                    aprobación. <br />• Propietarios de inmuebles y agentes
                    inmobiliarios implicados en el proceso de arrendamiento,
                    para consultar el perfil económico y adoptar decisiones
                    informadas en relación con el arrendamiento.
                  </p>
                  <p>
                    SKOR garantiza la adopción de medidas técnicas y
                    organizativas para proteger la seguridad de los datos y
                    asegura que no se cederán datos personales a otros terceros,
                    salvo obligación legal.
                  </p>
                  <p>
                    Podrá ejercer sus derechos de acceso, rectificación,
                    supresión, oposición, limitación del tratamiento,
                    portabilidad y derecho al olvido, así como revocar su
                    consentimiento, enviando su solicitud a info@skortorent.com.
                    También podrá presentar una reclamación ante la Agencia
                    Española de Protección de Datos (www.aepd.es).
                  </p>
                  <p>
                    Confirmo haber leído y comprendido el contenido de este
                    documento, otorgando mi consentimiento libre, específico,
                    informado e inequívoco para la cesión de mis datos
                    personales en los términos expuestos.
                  </p>
                </div>
              )}
            </div>

            <div class="table-responsive py-3">
              <table class="table table-bordered table-striped">
                <thead class="table-dark">
                  <tr className="consent-form-title">
                    <th>Tipología / Type</th>
                    <th>Entidad / Entity</th>
                    <th>NIF / Company ID</th>
                    <th>Dirección / Address</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      Compañías de crédito y ficheros de solvencia patrimonial
                    </td>
                    <td>EQUIFAX IBÉRICA, S.L.</td>
                    <td>B80855398</td>
                    <td>
                      PASEO CASTELLANA (TORRE ESPACIO), 259 - D, 28046, Madrid
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Compañías de crédito y ficheros de solvencia patrimonial
                    </td>
                    <td>Experian España S.L.U</td>
                    <td>B95017844</td>
                    <td>
                      C/ Príncipe de Vergara, 132. 1ª Planta. 28002 Madrid
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Compañías de crédito y ficheros de solvencia patrimonial
                    </td>
                    <td>Experian Bureau de Crédito S.A.U.</td>
                    <td>A82120601</td>
                    <td>
                      C/ Príncipe de Vergara, 132. 1ª Planta. 28002 Madrid
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Compañías de crédito y ficheros de solvencia patrimonial
                    </td>
                    <td>AXESOR CONOCER PARA DECIDIR S.A.</td>
                    <td>A18413302</td>
                    <td>
                      C/ Graham Bell. Edificio Experian s/n de Armilla (Granada)
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Compañías de crédito y ficheros de solvencia patrimonial
                    </td>
                    <td>BANCO DE ESPAÑA</td>
                    <td>Q2802472G</td>
                    <td>C/Alcalá 48, 28014, Madrid, España</td>
                  </tr>
                  <tr>
                    <td>Compañías aseguradoras</td>
                    <td>
                      MUTUA DE PROPIETARIOS SEGUROS Y REASEGUROS A PRIMA FIJA
                      MUTUA
                    </td>
                    <td>G08171332</td>
                    <td>C/ Londres, 29, 08029, Barcelona (España)</td>
                  </tr>
                  <tr>
                    <td>Compañías aseguradoras</td>
                    <td>Onlygal Seguros y Reaseguros, S.A.U.</td>
                    <td>A08055196</td>
                    <td>
                      PLAZA EUROPA, 41 - 43 P. 6, L'HOSPITALET DE LLOBREGAT,
                      Barcelona
                    </td>
                  </tr>
                  <tr>
                    <td>Compañías aseguradoras</td>
                    <td>
                      CAJA DE SEGUROS REUNIDOS, Compañía de Seguros y
                      Reaseguros, S.A
                    </td>
                    <td>A28013050</td>
                    <td>Avenida de Burgos 109, 28050 Madrid</td>
                  </tr>
                  <tr>
                    <td>Compañías aseguradoras</td>
                    <td>GALLEN INSURANCE UNDERWRITING SL</td>
                    <td>B92833490</td>
                    <td>C/ Maria de Molina, 37 – 28006 – Madrid</td>
                  </tr>
                  <tr>
                    <td>Compañías aseguradoras</td>
                    <td>MAPFRE ESPAÑA, COMPAÑIA DE SEGUROS Y REASEGUROS SA</td>
                    <td>A28141935</td>
                    <td>Carretera de Pozuelo, 50, 28222 Majadahonda, Madrid</td>
                  </tr>
                  <tr>
                    <td>Compañías aseguradoras</td>
                    <td>ARAG SE, SUCURSAL EN ESPAÑA</td>
                    <td>W0049001A</td>
                    <td>C/ Núñez de Balboa 120 28006 Madrid</td>
                  </tr>
                  <tr>
                    <td>Compañías aseguradoras</td>
                    <td>ARAG SERVICES SPAIN & PORTUGAL, SL.</td>
                    <td>B64507171</td>
                    <td>C/ Núñez de Balboa 120 28006 Madrid</td>
                  </tr>
                  <tr>
                    <td>Compañías aseguradoras</td>
                    <td>
                      Mutua Madrileña Automovilista, Sociedad de Seguros a Prima
                      Fija
                    </td>
                    <td>V28027118</td>
                    <td>Paseo de la Castellana, 33, 28046 de Madrid</td>
                  </tr>
                  <tr>
                    <td>Compañías aseguradoras</td>
                    <td>SANTA LUCÍA, S A., Compañía de Seguros y Reaseguros</td>
                    <td>A28039790</td>
                    <td>Plaza de España, 15, 28008, Madrid, España</td>
                  </tr>
                  <tr>
                    <td>Compañías aseguradoras</td>
                    <td>ALLIANZ, COMPAÑÍA DE SEGUROS Y REASEGUROS, S.A.</td>
                    <td>A28007748</td>
                    <td>C/ Ramírez de Arellano, 35, 28043 de Madrid</td>
                  </tr>
                  <tr>
                    <td>Terceros colaboradores del sector financiero</td>
                    <td>Fintonic Servicios Financieros, SL</td>
                    <td>B86289956</td>
                    <td>
                      Paseo castellana, 163 - piso 1, madrid, 28046, madrid
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="d-flex align-items-center justify-content-center gap-3 step-btns-group">
              <button
                disabled={consentDocLoading}
                onClick={handleAddConsent}
                className="btn btnorange step-btn"
              >
                {consentDocLoading
                  ? _t("submitting")
                  : _t("agree", "Agree button on Document Sign page")}
              </button>
            </div>
          </Container>
        </>
      )}
    </>
  );
};

export default GdprConsent;
